export const MIXPANEL_COOKIE_NAME = 'mp-device-id';
